export var FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO';
export var SUCCESS_FETCH_CLIENT_INFO = 'SUCCESS_FETCH_CLIENT_INFO';
export var FAILURE_FETCH_CLIENT_INFO = 'FAILURE_FETCH_CLIENT_INFO';



// WEBPACK FOOTER //
// ./src/actions/client.js